import ExpansionPanel from "components/templatesComponents/ExpansionPanel";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import scrollIntoView from "scroll-into-view-if-needed";

const Accordion = (props) => {
  let { panels = [] } = props;
  const { noPadding = false, expansionPanelRole = undefined } = props;
  if (panels && !Array.isArray(panels)) {
    panels = [panels];
  }
  const listRef = useRef(Array.from({ length: panels.length }));

  const [expanded, setExpanded] = useState(false);

  const handleChange = (index) => (_, isExpanded) => {
    setExpanded(isExpanded ? index : false);
  };

  useEffect(() => {
    // on close, scroll to the ref element
    if (expanded !== false) {
      setTimeout(() => {
        scrollIntoView(listRef.current[expanded]);
      }, 0);
    }
  }, [expanded]);

  return (
    <div role="list">
      {(panels || []).map((panel, index) => {
        const isExpanded = index === expanded;
        return (
          <div role="listitem" className="accordion-item" key={panel.id}>
            <ExpansionPanel
              {...panel}
              ref={(el) => (listRef.current[index] = el)}
              initialExpanded={isExpanded}
              onChange={handleChange(index)}
              noPadding={noPadding}
              role={expansionPanelRole}
            />
          </div>
        );
      })}
    </div>
  );
};

Accordion.propTypes = {
  panels: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape()), PropTypes.shape()]),
  noPadding: PropTypes.bool,
  expansionPanelRole: PropTypes.string,
};

export default Accordion;
